import { NgModule, Optional, SkipSelf } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { CartEffects } from './cart.effects';
import { ICartFeature } from './cart.feature.state';
import { CartReducer } from './cart.reducer';
import { nameof } from '@symphony-solo/shared/utils/src';

@NgModule({
  imports: [
    StoreModule.forFeature(nameof<ICartFeature>('CartFeature'), CartReducer),
    EffectsModule.forFeature([CartEffects]),
  ],
})
export class CartStateModule {
  public constructor(
    @Optional()
    @SkipSelf()
    parentModule: CartStateModule
  ) {
    if (parentModule) {
      throw new Error('CartStateModule is already loaded. Import it in the AppModule only');
    }
  }
}
